import React, {Component} from 'react';
import { Helpers } from '../core/src/helpers';

import './css/index.less';

const shareButtons = {
  'facebook' : {
    link: (props) => {
      return 'https://www.facebook.com/sharer.php?' + Helpers.paramsToString({
        u: props.url,
        quote: props.text,
        utm_source: props.utm_source,
        utm_medium: props.utm_medium,
        utm_campaign: props.utm_campaign,
        utm_content: props.utm_content,
      });
    },
    className: 'facebook-icon'
  },
  'linkedin' : {
    link: (props) => {
      return 'https://linkedin.com/shareArticle?' + Helpers.paramsToString({
        url: props.url,
        title: props.text,
        utm_source: props.utm_source,
        utm_medium: props.utm_medium,
        utm_campaign: props.utm_campaign,
        utm_content: props.utm_content,
      });
    },
    className: 'linkedin-icon'
  },
  'twitter' : {
    link: (props) => {
      return 'https://twitter.com/share?' + Helpers.paramsToString({
        url: props.url,
        text: props.text,
        utm_source: props.utm_source,
        utm_medium: props.utm_medium,
        utm_campaign: props.utm_campaign,
        utm_content: props.utm_content,
      });
    },
    className: 'twitter-icon'
  },
  'reddit' : {
    link: (props) => {
      return 'https://www.reddit.com/submit?' + Helpers.paramsToString({
        url: props.url,
        title: props.text,
      });
    },
    className: 'reddit-icon'
  },
  'email' : {
    link: (props) => {
      return 'mailto:?subject=' + props.text + '&body=' +  props.extraText + '&utm_source=' + props.utm_source + '&utm_medium=' + props.utm_medium + '&utm_campaign=' + props.utm_campaign + '&utm_content=' + props.utm_content;
    },
    className: 'email-icon'
  },
}

class ShareActionButton extends Component {

  static defaultProps = {
      utm_source: "hp",
      utm_medium: "organic",
      utm_campaign: "share_article",
      utm_content: "social_sharing_button"
  }


  openWindow = () => {

    const {type, text="", extraText="", utm_source, utm_medium, utm_campaign, utm_content} = this.props;
    const url = window.location.href;
    const link = shareButtons[type.toLowerCase()].link({url, text, extraText, utm_source, utm_medium, utm_campaign, utm_content});

    const {
      windowWidth,
      windowHeight,
    } = this.props;

    const windowOptions = {
      height: windowHeight,
      width: windowWidth,
    };
    this.windowOpen(link, windowOptions);

  }

  windowOpen = (url, { name="", height = 400, width = 550 }) => {
    /* eslint-disable no-mixed-operators */
    const left = (window.outerWidth / 2) + (window.screenX || window.screenLeft || 0) - (width / 2);
    const top = (window.outerHeight / 2) + (window.screenY || window.screenTop || 0) - (height / 2);

    /* eslint-enable no-mixed-operators */
    const config = {
      height,
      width,
      left,
      top,
      location: 'no',
      toolbar: 'no',
      status: 'no',
      directories: 'no',
      menubar: 'no',
      scrollbars: 'yes',
      resizable: 'no',
      centerscreen: 'yes',
      chrome: 'yes',
    };
    const shareDialog = window.open(url, '', Object.keys(config).map(key => `${key}=${config[key]}`).join(', '));
    return shareDialog;
  }

  render() {

    const {type="", title=""} = this.props;
    let shareButton = shareButtons[type.toLowerCase()];
    return (
      <div className="share-action-button" onClick={this.openWindow}>
        <img
          className={shareButton && shareButton.className ? shareButton.className : null }
          src={shareButton ? shareButton.icon : ""}
          alt={title ? "Share " + title + (type === "Email" ? " via " : " on ") + type : "Share " + (type === "Email" ? "via " : "on ") + type }
          title={title ? "Share " + title + (type === "Email" ? " via " : " on ") + type : "Share " + (type === "Email" ? "via " : "on ") + type}/>
      </div>
    );
  }
}

export default ShareActionButton;
